import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { BERTypeEnum, PropertyActivity } from '../../shared/generated';
import { getLocalTranslation } from '../../utils/i18nKit';
export var getQuoteAccountancyProfessionalAssociationsMemberList = function getQuoteAccountancyProfessionalAssociationsMemberList() {
  return [{
    value: 'ICEAW',
    label: 'ICAEW',
    checked: true
  }, {
    value: 'ICAS',
    label: 'ICAS',
    checked: false
  }, {
    value: 'ICAI',
    label: 'ICAI',
    checked: false
  }, {
    value: 'ACCA',
    label: 'ACCA',
    checked: false
  }, {
    value: 'AAT',
    label: 'AAT',
    checked: false
  }, {
    value: 'AIA',
    label: 'AIA',
    checked: false
  }, {
    value: 'CIMA',
    label: 'CIMA',
    checked: false
  }, {
    value: 'CIOT',
    label: 'CIOT',
    checked: false
  }, {
    value: 'none',
    label: 'None of the above',
    checked: false
  }];
};
export var getQuoteAccountancyActivityList = function getQuoteAccountancyActivityList() {
  return [{
    value: 'account111',
    label: 'General Accounting & Audit – Banks and Financial Institutions'
  }, {
    value: 'account222',
    label: 'Tax Advisory Services'
  }, {
    value: 'account333',
    label: 'Bookkeeping & Payroll Services'
  }, {
    value: 'account444',
    label: 'Computer Consultancy Services'
  }, {
    value: 'account555',
    label: 'Management & Business Consultancy'
  }];
};
export var rent2RentBusinessActivityOptionsMap = {
  propertySourcingOnly: {
    value: 'property_sourcing_only',
    label: 'Property Sourcing Only'
  },
  r2rAndPropertySourcing: {
    value: 'r2r_and_property_sourcing',
    label: 'Property Sourcing and Rent to Rent'
  },
  r2rOnly: {
    value: 'r2r_only',
    label: 'Rent to Rent Only'
  }
};
export var getRent2RentBusinessActivityOptionList = function getRent2RentBusinessActivityOptionList() {
  return Object.values(rent2RentBusinessActivityOptionsMap);
};
export var getBERWorkTypeMap = function getBERWorkTypeMap() {
  var _ref;

  return _ref = {}, _defineProperty(_ref, BERTypeEnum.DOMESTIC_BER, {
    value: BERTypeEnum.DOMESTIC_BER,
    label: 'Domestic BER'
  }), _defineProperty(_ref, BERTypeEnum.NON_DOMESTIC_BER, {
    value: BERTypeEnum.NON_DOMESTIC_BER,
    label: 'Non-Domestic BER'
  }), _defineProperty(_ref, BERTypeEnum.DISPLAY_ENERGY_CERTIFICATE, {
    value: BERTypeEnum.DISPLAY_ENERGY_CERTIFICATE,
    label: 'Display Energy Certificate (DEC)'
  }), _ref;
};
export var getBERWorkTypeList = function getBERWorkTypeList() {
  return Object.values(getBERWorkTypeMap());
};
export var getBusinessActivityAdditionalActivityMap = function getBusinessActivityAdditionalActivityMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    propertyEstateManagementNonRics: {
      value: PropertyActivity.ESTATE_PROPERTY_MANAGEMENT_NON_RICS,
      label: $t('kit:quotes.property_estate_management_non_rics')
    },
    propertySearchAgency: {
      value: PropertyActivity.PROPERTY_SEARCH_AGENCY,
      label: $t('kit:quotes.property_search_agency')
    },
    estateAgentAndOrLettingAgent: {
      value: PropertyActivity.ESTATE_AGENT_LETTING_AGENT,
      label: $t('kit:quotes.estate_agent_and_or_letting_agent')
    },
    propertySourcing: {
      value: PropertyActivity.PROPERTY_SOURCING,
      label: $t('kit:quotes.property_sourcing')
    },
    residentialPropertyOperatorRentToRent: {
      value: PropertyActivity.R2R_OPERATOR,
      label: $t('kit:quotes.residential_property_operator_rent_to_rent')
    }
  };
};
export var getQuoteAccelerantAdditionalBusinessActivityList = function getQuoteAccelerantAdditionalBusinessActivityList() {
  return Object.values(getBusinessActivityAdditionalActivityMap());
};